var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNew = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2347_14904)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.3334 8.00068L13.7067 6.14734L13.9334 3.69401L11.5267 3.14734L10.2667 1.02734L8.00008 2.00068L5.73341 1.02734L4.47341 3.14734L2.06675 3.68734L2.29341 6.14068L0.666748 8.00068L2.29341 9.85401L2.06675 12.314L4.47341 12.8607L5.73341 14.9807L8.00008 14.0007L10.2667 14.974L11.5267 12.854L13.9334 12.3073L13.7067 9.85401L15.3334 8.00068ZM12.3267 9.40734L12.5001 11.2673L10.6734 11.6807L9.72008 13.2873L8.00008 12.5473L6.28008 13.2873L5.32675 11.6807L3.50008 11.2673L3.67341 9.40068L2.44008 8.00068L3.67341 6.58734L3.50008 4.73401L5.32675 4.32734L6.28008 2.72068L8.00008 3.45401L9.72008 2.71401L10.6734 4.32068L12.5001 4.73401L12.3267 6.59401L13.5601 8.00068L12.3267 9.40734ZM7.33341 10.0007H8.66675V11.334H7.33341V10.0007ZM7.33341 4.66734H8.66675V8.66734H7.33341V4.66734Z",
  fill: "#0A4A5C"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2347_14904"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNew);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/new.a65df14eeee2bc3a9e6ab20bafc5a418.svg";